module.exports = __webpack_public_path__ + "static/media/AllReports.583b600c.png";